import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../apiClient';

export interface ProjectSettings {
  workingDays?: number[];
  [key: string]: unknown;
}

export function useProjectSettings() {
  return useQuery<ProjectSettings, Error>({
    queryKey: ['project-settings'],
    queryFn: async ({ signal }) => {
      const res = await apiFetch('/api/project-settings', { signal });
      if (!res.ok) throw new Error(`API ${res.status}: /api/project-settings`);
      return res.json();
    },
    staleTime: 60_000,
  });
}
